<div class="row">
    <div class="col-sm-12">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="borderStyle">Border Style</label></div>
            <ccl-simple-select formId="borderStyle"
                [listOfItems]="borderStyles"
                (valueChange)="sharedService.tabsConfig.borderStyle = $event.value"
                [value]="sharedService.tabsConfig.borderStyle"
                [bindLabel]="'label'"
                [bindValue]="'code'"
            >
            </ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="selectedLabel">Selected Label Color</label></div>
            <div
                class="input-group"
                [(colorPicker)]="sharedService.tabsConfig.activeLabelColor"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
            >
                <input id="selectedLabel"
                    cclFormInput
                    type="text"
                    [(ngModel)]="sharedService.tabsConfig.activeLabelColor"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': sharedService.tabsConfig.activeLabelColor }"
                        >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="selectedUnderline">Selected Underline Color</label></div>
            <div
                class="input-group"
                [(colorPicker)]="sharedService.tabsConfig.activeBorderColor"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'left'"
            >
                <input id="selectedUnderline"
                    cclFormInput
                    type="text"
                    [(ngModel)]="sharedService.tabsConfig.activeBorderColor"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': sharedService.tabsConfig.activeBorderColor }"
                        >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="unselectedLabel">Unselected Label Color</label></div>
            <div
                class="input-group"
                [(colorPicker)]="sharedService.tabsConfig.inactiveLabelColor"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'top'"
            >
                <input id="unselectedLabel"
                    cclFormInput
                    type="text"
                    [(ngModel)]="sharedService.tabsConfig.inactiveLabelColor"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': sharedService.tabsConfig.inactiveLabelColor }"
                        >&nbsp;</span
                    >
                </div>
            </div>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="unselectedUnderline">Unselected Underline Color</label></div>
            <div
                class="input-group"
                [(colorPicker)]="sharedService.tabsConfig.inactiveBorderColor"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'top'"
            >
                <input id="unselectedUnderline"
                    cclFormInput
                    type="text"
                    [(ngModel)]="sharedService.tabsConfig.inactiveBorderColor"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': sharedService.tabsConfig.inactiveBorderColor }"
                        >&nbsp;</span
                    >
                </div>
            </div>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div *ngIf="false" class="col-sm-12">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="cssStyling">CSS Styling</label></div>
            <textarea id="cssStyling" rows="10" class="form-control" [(ngModel)]="sharedService.tabsConfig.customCss"></textarea>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>
